import usStates from 'src/constants/usStates';

function validateUsState(state: string): boolean {
  const shorts = usStates.map(usState => usState.short);
  return shorts.includes(state);
}

export default validateUsState;
